import {Options, TableColumn} from '@fl/cmsch-fe-library';

import {RoleView} from 'api/gen/RoleView';

/**
 * Builds the admin roles table columns.
*
* @param discriminatorOptions Available discriminator options for the table filter.
* @returns Table columns for the roles table.
*/
// eslint-disable-next-line max-lines-per-function
export const rolesColumns = (discriminatorOptions: Options<number>): Array<TableColumn<RoleView>> => [
    {
        field: 'code',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'discriminatorId',
        type: 'option',
        options: discriminatorOptions,
        filterTypes: ['multiSelectNumber'],
        customFiltersOnly: true,
    },
    {
        field: 'name',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'permissionCount',
        type: 'number',
    },
    {
        field: 'userCount',
        type: 'number',
    },
    {
        field: 'userEnable',
        type: 'boolean',
    },
];
